<script lang="ts">
export default {
  name: 'IonCheckmarkSharp'
}
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512">
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="square"
      stroke-miterlimit="10"
      stroke-width="44"
      d="M416 128L192 384l-96-96"
    ></path>
  </svg>
</template>
